import { render, staticRenderFns } from "./ParkingSpaceMarker.vue?vue&type=template&id=4c53bea2&"
import script from "./ParkingSpaceMarker.vue?vue&type=script&lang=js&"
export * from "./ParkingSpaceMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports